import AttorneyHubAPIService from "_shared/_api/attorney-hub-api-service";
import axios, { AxiosHeaders, CanceledError } from "axios";
import Session from "users/__session/session";
import { VendorTeamJSON } from "work/work-agreements/teams/vendor-team/_schemas/vendor-team-schema";

export default class TeamsAPIService {
  private readonly authHeaders: AxiosHeaders = new AxiosHeaders();


  constructor(session: Session) {
    if (!session.authToken?.value)
      throw new Error("Session must have an authToken to create a TeamsAPIService");
    this.authHeaders.set("Authorization", `Bearer ${session.authToken.value}`);
  }

  async getActiveTeamsAsync(
    workingForMe: boolean,
    abortController?: AbortController
  ): Promise<VendorTeamJSON[]> {
    const url = new URL(`/work/vendor-teams?workingForMe=${workingForMe}`, AttorneyHubAPIService.apiBaseUrl);
    try {
      const response = await axios.get(
        url.toString(),
        {
          headers: this.authHeaders,
          signal: abortController?.signal,
        }
      );
      return response.data;
    } catch (error) {
      if (error instanceof CanceledError) throw error;
      throw new InvalidVendorTeamError("getActiveTeamsAsync", error);
    }
  }
}

export class InvalidVendorTeamError extends Error {
  public method: string;
  public error: unknown;
  constructor(method: string, error: unknown) {
    super(`Error in ${method}: ${String(error)}`);
    this.method = method;
    this.error = error;
    this.name = "InvalidVendorTeamError";
  }
}